import Vue from "vue"

export default {
	byName({}, name) {
		return Vue.api.get('user/by-fml/name', {
			term: name
		})
	},
	byPhone({}, number) {
		return Vue.api.get('user/by-phone/' + number)
	},
	list({}, filter) {
		return Vue.api.post('user/list', {
			"per_page": filter.per_page || 10,
			"current_page": filter.current_page || 1
		})
	},
	get({}, id) {
		return Vue.api.get('user/' + id)
	},
	create({}, data) {
		return Vue.api.post('user/', data)
	},
	update({dispatch}, data) {
		if (!data._id) {
			return dispatch('create', data)
		}

		return Vue.api.put('user/' + data._id, data)
	},
	delete({}, id) {
		return Vue.api.delete('user/' + id)
	}
}



// WEBPACK FOOTER //
// ./src/vuex/services/user/actions.js